import React from "react";
import { ButtonGroup, Stack } from "@mui/material";
import { Editor } from "@tiptap/core";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import ToolbarButton from "./ToolbarButton";

export interface MentionEditorToolbarProps {
  editor: Editor;
  disabled?: boolean;
}

/** Lean formatting toolbar: bold, italic, underline, bullet list, numbered list. */
const MentionEditorToolbar: React.FC<MentionEditorToolbarProps> = ({ editor, disabled = false }) => {
  return (
    <Stack direction="row" spacing={1} mb={1} alignItems="center">
      <ButtonGroup variant="outlined" size="small">
        <ToolbarButton
          onClick={() => editor.chain().focus().toggleBold().run()}
          isActive={editor.isActive("bold")}
          disabled={disabled}
        >
          <FormatBoldIcon fontSize="small" />
        </ToolbarButton>

        <ToolbarButton
          onClick={() => editor.chain().focus().toggleItalic().run()}
          isActive={editor.isActive("italic")}
          disabled={disabled}
        >
          <FormatItalicIcon fontSize="small" />
        </ToolbarButton>

        <ToolbarButton
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          isActive={editor.isActive("underline")}
          disabled={disabled}
        >
          <FormatUnderlinedIcon fontSize="small" />
        </ToolbarButton>

        <ToolbarButton
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          isActive={editor.isActive("bulletList")}
          disabled={disabled}
        >
          <FormatListBulletedIcon fontSize="small" />
        </ToolbarButton>

        <ToolbarButton
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          isActive={editor.isActive("orderedList")}
          disabled={disabled}
        >
          <FormatListNumberedIcon fontSize="small" />
        </ToolbarButton>
      </ButtonGroup>
    </Stack>
  );
};

export default MentionEditorToolbar;
